var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardWeatherGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.06 30.59H44.97V125.07H122.06V30.59Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.12 20.33V36H57.48V20.33H73C72.9569 18.947 73.1922 17.5695 73.6917 16.2792C74.1912 14.9889 74.9448 13.8122 75.9078 12.8187C76.8708 11.8252 78.0236 11.0354 79.2977 10.496C80.5719 9.95654 81.9414 9.67859 83.325 9.67859C84.7086 9.67859 86.0781 9.95654 87.3522 10.496C88.6263 11.0354 89.7791 11.8252 90.7421 12.8187C91.7052 13.8122 92.4588 14.9889 92.9583 16.2792C93.4578 17.5695 93.693 18.947 93.65 20.33H109.12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82.06C103.997 84.7449 102.929 87.3189 101.029 89.2165C99.13 91.1141 96.5549 92.18 93.87 92.18H81.05C79.6593 92.1201 78.3455 91.5255 77.3827 90.5203C76.4198 89.5151 75.8823 88.1769 75.8823 86.785C75.8823 85.393 76.4198 84.0549 77.3827 83.0497C78.3455 82.0445 79.6593 81.4499 81.05 81.39C81.998 81.3861 82.9299 81.6346 83.75 82.11C83.75 79.426 84.8162 76.8519 86.7141 74.9541C88.6119 73.0562 91.186 71.99 93.87 71.99C96.554 71.99 99.128 73.0562 101.026 74.9541C102.924 76.8519 103.99 79.426 103.99 82.11L104 82.06Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.67 69.6099L78.67 74.6699C77.6668 74.6818 76.6827 74.3952 75.8427 73.8465C75.0027 73.2978 74.3449 72.5117 73.9527 71.5883C73.5605 70.6648 73.4517 69.6455 73.6401 68.6601C73.8285 67.6746 74.3056 66.7674 75.0108 66.0537C75.716 65.3401 76.6175 64.8522 77.6006 64.652C78.5838 64.4519 79.6042 64.5485 80.5323 64.9296C81.4604 65.3108 82.2542 65.9593 82.8129 66.7926C83.3716 67.626 83.67 68.6066 83.67 69.6099Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3601 61.1V53.48",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.21 62.29L69.73 56.13",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.75 66.2699L63.51 63.9199",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2901 71.5299L63.05 73.8899",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9399 67.68L94.1799 65.33",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.01 76.0599L68.54 82.2199",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.22 63.16L88.69 57",
    stroke: "white",
    strokeWidth: 0.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.67 23.86H127.86C127.943 23.86 128.025 23.8763 128.101 23.9079C128.177 23.9396 128.247 23.986 128.305 24.0445C128.364 24.103 128.41 24.1725 128.442 24.2489C128.474 24.3253 128.49 24.4073 128.49 24.49V131.17C128.49 131.337 128.424 131.497 128.305 131.615C128.187 131.734 128.027 131.8 127.86 131.8H107.39",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.55 38.75V24.49C38.55 24.3229 38.6164 24.1627 38.7346 24.0445C38.8527 23.9264 39.013 23.86 39.18 23.86H56.91",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3 24.8499C85.7964 24.8499 87.82 22.8263 87.82 20.3299C87.82 17.8336 85.7964 15.8099 83.3 15.8099C80.8037 15.8099 78.78 17.8336 78.78 20.3299C78.78 22.8263 80.8037 24.8499 83.3 24.8499Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.67 30.09H63.9399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.48 30.34V20.34H73C72.9569 18.957 73.1922 17.5795 73.6917 16.2892C74.1912 14.999 74.9448 13.8222 75.9078 12.8287C76.8708 11.8352 78.0236 11.0454 79.2977 10.506C80.5719 9.96655 81.9414 9.6886 83.325 9.6886C84.7086 9.6886 86.0781 9.96655 87.3522 10.506C88.6263 11.0454 89.7791 11.8352 90.7421 12.8287C91.7052 13.8222 92.4588 14.999 92.9583 16.2892C93.4578 17.5795 93.693 18.957 93.65 20.34H109.14V30.34",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 104.68H109.34",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 111.9H96.43",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1799 52.47V46.24H56.9099V45.1H62.7699V46.24H60.4999V52.47H59.1799Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9301 104.27L32.8901 104.89L30.0901 72.8899L39.9301 72.0199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.32 65.75L27.71 58.82L29.16 58.6899L31.69 63.56H31.78L33.42 58.33L34.87 58.2L35.48 65.1299L34.32 65.2399L33.9 60.36H33.83L32.32 65.1299L31.43 65.2099L29.11 60.77H29.05L29.47 65.65L28.32 65.75Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.76 116.02L39.86 115.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.26 123.22L39.86 122.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.66 125.07L100.44 132.68C100.468 133.021 100.359 133.359 100.138 133.619C99.9164 133.88 99.6007 134.042 99.26 134.07L24.83 140C24.5218 140.017 24.2194 139.912 23.9876 139.708C23.7558 139.504 23.6131 139.218 23.59 138.91L15.51 46.56C15.4785 46.2587 15.5652 45.9569 15.7517 45.7182C15.9382 45.4795 16.21 45.3224 16.51 45.28L45 42.37",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardWeatherGrey);
export default __webpack_public_path__ + "static/media/clipboard_weather_grey.5ea112a83cb8e51c1c149d1ebb30cae2.svg";
export { ForwardRef as ReactComponent };